import styled from '@emotion/styled';
import React from 'react';
import PropTypes from 'prop-types';

import Spinner from '~/components/Spinner';
import { calcVw } from '~/styles/helpers';

const Block = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;

    ${({ fullWidth }) =>
        fullWidth &&
        `
        height: 100vh;
        width: ${calcVw(100)};
        
        top: 0;
        bottom: 0;
        left: 50%;
        right: 50%;
        margin: 0 ${calcVw(-50)};
    `}
`;

const Loader = ({ fullWidth = true }) => {
    return (
        <Block {...{ fullWidth }}>
            <Spinner />
        </Block>
    );
};

Loader.propTypes = {
    fullWidth: PropTypes.bool
};

export default Loader;
